import { Divider } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { Field, useFormikContext } from 'formik';
import * as React from 'react';
import { useObservable } from 'react-use-observable';
import { ListRadioButtonFormField } from 'v2/components/Shared/FormFields/ListRadioButton';
import { SelectFormField } from 'v2/components/Shared/FormFields/SelectFormField';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';
import { EContractStatus } from 'v2/interfaces/subscriptions';
import { dateService } from 'v2/services/date';
import subscriptionsService from 'v2/services/subscriptions';

import { useStyles } from './styles';

import type { IPartnerRefundReason } from '../partner';

type ContractCancellationProps = {
  contractId: number;
};

const OTHER_CONTRACT_CANCEL_REASON = 1;

function ContractCancellation({ contractId }: ContractCancellationProps) {
  const classes = useStyles();
  const [cancelReasons] = useObservable(() => subscriptionsService.getSubscriptionCancelReasons(), []);
  const [contract] = useObservable(() => subscriptionsService.getSubscription(contractId), [contractId]);
  const [removeAccessDate] = useObservable(() => subscriptionsService.getRemoveAccessDate(contractId), [contractId]);
  const { values } = useFormikContext<IPartnerRefundReason>();

  const cancelReasonFormat = (cancelReasons || []).map((item) => ({
    label: item.name,
    value: item.id,
  }));

  const contractOtherReasonSelected = values.cancelContractMotive === OTHER_CONTRACT_CANCEL_REASON;

  if (!contract) return null;

  const notAllowedStatuses = [EContractStatus.CANCELADO, EContractStatus.FINALIZADO];
  if (notAllowedStatuses.includes(contract.payment_status.id)) return null;

  return (
    <>
      <Divider className={classes.divider} />
      <Typography className={classes.title} variant='h6'>
        Essa fatura pertence ao contrato <strong>{contractId}</strong>. O reembolso da fatura não cancela o contrato de recorrência. Deseja também
        cancelar o contrato?
      </Typography>
      <p className={classes.subtitle}>
        {removeAccessDate && (
          <>
            Caso confirme o cancelamento, o cliente terá acesso ao conteúdo até{' '}
            <strong className={classes.removeAccessDate}>{dateService.dateToString(new Date(removeAccessDate), 'dd/MM/yyyy')}</strong>
          </>
        )}
      </p>
      <Field
        row
        id='cancelContract'
        name='cancelContract'
        options={[
          { label: 'Sim', value: true },
          { label: 'Não', value: false },
        ]}
        component={ListRadioButtonFormField}
      />
      {values.cancelContract && (
        <Field
          className={contractOtherReasonSelected ? classes.motiveSelect : undefined}
          id='cancelContractMotive'
          name='cancelContractMotive'
          options={cancelReasonFormat}
          component={SelectFormField}
          fullWidth
          label='Selecione o motivo do cancelamento do contrato:'
        />
      )}
      {contractOtherReasonSelected && values.cancelContract && (
        <Field
          id='cancelContractDetail'
          name='cancelContractDetail'
          multiline
          fullWidth
          InputProps={{ rows: 3, disableUnderline: true }}
          InputLabelProps={{ shrink: true }}
          placeholder='Descreva o motivo do cancelamento desse contrato. (Lembre-se de que essa informação será direcionada ao cliente.)'
          component={TextFormField}
        />
      )}
    </>
  );
}

export { ContractCancellation };
